import React from 'react';
import { Handle, Position } from '@xyflow/react';

const NODE_SIZE = { width: 220, height: 120 };

function StorageAccountNode({ data, selected }) {
  return (
    <div
      className={`relative rounded-lg border-2 p-3 transition-colors ${
        selected
          ? 'border-orange-500 bg-orange-50/70 dark:bg-orange-900/30'
          : 'border-orange-300 bg-orange-50/40 dark:bg-orange-900/20'
      }`}
      style={NODE_SIZE}
    >
      <Handle type="target" position={Position.Top} className="!bg-orange-500" />
      <div className="mb-1 flex items-center gap-2">
        <svg
          className="h-4 w-4 text-orange-600 dark:text-orange-400 shrink-0"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <path d="M9 22V12h6v10" />
        </svg>
        <span className="text-sm font-semibold text-orange-900 dark:text-orange-100 truncate">
          {data.name}
        </span>
      </div>
      {data.accountTier && (
        <span className="inline-block bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200 text-xs font-mono px-2 py-0.5 rounded">
          {data.accountTier}
        </span>
      )}
      {data.replicationType && (
        <span className="ml-1 inline-block bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200 text-xs font-mono px-2 py-0.5 rounded">
          {data.replicationType}
        </span>
      )}
      <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Storage Account</div>
      <Handle type="source" position={Position.Bottom} className="!bg-orange-500" />
    </div>
  );
}

export default StorageAccountNode;
